import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Text } from '@uhg-abyss/web/ui/Text';
import { type MessageButton } from '../types/message.types';

interface ChatResponseButtonsProps {
  buttons: MessageButton[];
  disabled: boolean;
  onButtonPress: (button: MessageButton) => void;
}

const ChatResponseButtons: React.FC<ChatResponseButtonsProps> = ({
  buttons,
  disabled,
  onButtonPress,
}) => {
  return (
    <ButtonContainer>
      {buttons.map((button) => (
        <div>
          <ResponseButton
            key={button.id}
            buttonOpacity={disabled ? 0.5 : 1}
            onClick={() => !disabled && onButtonPress(button)}
            type="button"
            disabled={disabled}
            aria-label={button.text}
          >
            <Text
              fontWeight="bold"
              fontSize="md"
              color={disabled ? '$core.color.neutral.50' : '$core.color.brand.60'}
            >
              {button.text}
            </Text>
          </ResponseButton>
        </div>
      ))}
    </ButtonContainer>
  );
};

const ButtonContainer = styled('div', {
  display: 'flex',
  marginTop: '$core.spacing.150',
  marginBottom: '$core.spacing.100',
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  gap: '$core.spacing.100',
  paddingLeft: '40px',
  flexDirection: 'column',
  textAlign: 'right',
});

const ResponseButton = styled('button', {
  padding: '$core.spacing.100 $core.spacing.150',
  backgroundColor: 'transparent',
  border: '1px solid $core.color.brand.60',
  alignItems: 'center',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  width: 'auto',
  color: '$core.color.brand.60',
  borderRadius: '$core.border-radius.xl',

  '& .abyss-text-root': {
    color: 'inherit',
    fontFamily: '$web.core.font-family.uhc2020-sans',
    fontWeight: '$web.core.font-weight.uhc2020-sans.bold',
    fontSize: 14,
  },

  '&:disabled': {
    cursor: 'not-allowed',
    opacity: 0.5,
  },

  '&:hover:not(:disabled)': {
    opacity: 0.8,
    backgroundColor: '$core.color.brand.60',
    color: '$core.color.neutral.0',
  },

  '&:active:not(:disabled)': {
    opacity: 0.6,
  },

  props: ({ buttonOpacity }: { buttonOpacity?: number }) => ({
    opacity: buttonOpacity,
    cursor: buttonOpacity === 1 ? 'pointer' : 'not-allowed',
  }),
});

export default ChatResponseButtons;
